if(!customElements.get('pagination-button-collection')){
    class CollectionListPaginationButton extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.btnLoadMore = this.querySelector('.btn-load-more');
            
            this.collectionsList = this.closest('.list-collections');
            this.collectionsWrapper = this.collectionsList.querySelector('#list-collections__collections-wrapper');
            this.collections = this.collectionsList.querySelector('#list-collections__collections');

            this.btnLoadMore.addEventListener('click', e => {
                e.preventDefault();

                this.btnLoadMore.setAttribute('data-disabled', 'true');

                this.loadMoreCollections();
            })
        }

        async loadMoreCollections(){
            try{
                const nextPageRes = await fetch(
                    `${this.btnLoadMore.dataset.url}`
                );
                const nextPageText = await nextPageRes.text();
                const nextPageHTML = new DOMParser().parseFromString(nextPageText, 'text/html');

                const collectionsWrapper = nextPageHTML.querySelector('#list-collections__collections-wrapper');
                const collections = nextPageHTML.querySelector('#list-collections__collections');

                const btnLoadMore = collectionsWrapper.querySelector('.btn-load-more');

                // get collection
                const collectionCards = collections.querySelectorAll('.collection-card__wrapper');
                collectionCards.forEach(item => {
                    this.collections.appendChild(item);
                })

                if(btnLoadMore){
                    this.btnLoadMore.classList.remove('d-none');
                    this.btnLoadMore.setAttribute('data-url', `${btnLoadMore.dataset.url}`);
                }else{
                    this.btnLoadMore.classList.add('d-none');
                }
            } catch(error){
                console.error(error);
            } finally {
                this.btnLoadMore.setAttribute('data-disabled', 'false');
            }
        }
    }

    customElements.define('pagination-button-collection', CollectionListPaginationButton);
}